<template>
  <div>
    <div>
      <h1>Klart!</h1>
    </div>
    <v-btn color="primary" @click="returnToHome">Fortsätt</v-btn>
  </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        methods: {
            returnToHome(){
                if ((this.$store.state.activeProfile.role == 'warehouse' || this.$store.state.activeProfile.role == 'hybrid-warehouse') && !this.$store.state.isDistributor) {
                    this.$router.push('Warehouse_Home');
                }else if (this.$store.state.activeProfile.role == 'driver' || this.$store.state.activeProfile.role == 'hybrid-driver') {
                    this.$store.commit('resetCustomer');
                    this.$store.commit('resetTransaction');
                    this.$router.push('Driver_Home');
                }else if (this.$store.state.isDistributor) {
                    this.$store.commit('resetDistributor');

                    this.$router.push('Warehouse_Home');
                }else {
                    this.$store.state.activeProfile = {};
                    this.$router.push('/');
                }
            }
        },
        created: function(){
            if(this.$store.state.auth.token == null || this.$store.state.auth.token == "" ){
                console.log("Profile Error: Please Login");
                this.$router.push('/');
            }

        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Complete.vue